import { apiClient } from '@api/apiClient';
import { logError } from '@utils/errorLogging';
import { createError } from '@utils/errorUtils';

import {
  CarrierLaneHistory,
  CarrierLaneSearch,
  LaneHistorySearchPayload,
  LaneSearchPayload,
} from './types';

export async function fetchLaneSearchData(payload: LaneSearchPayload) {
  try {
    const response: { value: CarrierLaneSearch[] } = await apiClient.post(
      '/Carrier/LaneSearch',
      payload,
    );
    return response.value;
  } catch (e: unknown) {
    logError('fetchLaneSearchData', e as Error);
    throw createError(e, 'Lane search failed. Please try again.');
  }
}

export const fetchLaneHistoryData = async (
  payload: LaneHistorySearchPayload,
) => {
  try {
    const response: { value: CarrierLaneHistory[] } = await apiClient.post(
      '/Carrier/lanehistorysearch',
      payload,
    );
    return response.value;
  } catch (e: unknown) {
    logError('fetchLaneHistoryData', e as Error);
    throw createError(e, 'Lane history search failed. Please try again.');
  }
};
